import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// --- ADD THESE IMPORTS ---
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// --- CREATE A DEFAULT THEME ---
const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* --- WRAP YOUR APP HERE --- */}
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* This fixes CSS inconsistencies */}
      <App />
    </ThemeProvider>
  </React.StrictMode>
);